import * as h from 'h'

import FacultyModel from 'models/FacultyModel'

import styles from './styles.scss'

export default ({ theme, faculty }) => {
  faculty = faculty instanceof FacultyModel ? faculty : FacultyModel.fromJS(faculty)

  return h.div(h.ca(styles.container, theme && theme.container),
    h.icon({
      ...h.ca(styles.blank, theme && theme.blank),
      name: 'user'
    }),
    h.div({
      ...h.ca(styles.avatar, theme && theme.avatar),
      style: { backgroundImage: faculty.netid ? `url(${faculty.facultyFaceUrl}` : '' }
    })
  )
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ProfilePicture/index.js